// removed by extract-text-webpack-plugin
module.exports = {"loading":"_cNRtwoABiEV7jcRJa4g3"};
    if(module.hot) {
      // 1542732365613
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  


//////////////////
// WEBPACK FOOTER
// ./src/components/Loading/index.module.css
// module id = 12
// module chunks = 0 1 7